<template>
  <div class="public-content platform-message">
    <div class="breadcrumb">折扣包管理</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <!-- <el-input v-model="formInline.code" placeholder="请输入平台号"></el-input> -->
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-input v-model="formInline.storeName" placeholder="请输入平台姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="formInline.status" placeholder="请选择" clearable>
                <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="折扣力度:">
              <el-select clearable v-model="formInline.discount" :filter-method="getDiscountList" filterable placeholder="请输入折扣力度">
                <el-option v-for="(item, index) in discountList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期"
                end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, searchPlateform()" round>查询</el-button>
            <el-button class="search-ok" v-if="$hasPermission('crm:admin:store:export')" v-permission="'crm:admin:store:export'" @click="exportExcel" round>导出Excel</el-button>
            <el-button class="search-ok" round type="primary" v-if="$hasPermission('crm:admin:store:apply')" v-permission="'crm:admin:store:apply'" @click="chack('', 'add')"> 关联平台 </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%" @size-change="sizeChange">
          <el-table-column prop="storeCode" label="平台号" min-width="10px"></el-table-column>
          <el-table-column prop="storeName" label="平台名称" min-width="10px"></el-table-column>
          <el-table-column prop="money" label="充值金额" min-width="10px"></el-table-column>
          <el-table-column prop="platformType" label="平台类型" min-width="10">
            <template v-slot="scope">
              <span>{{ scope.row.storeType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="discount" label="折扣力度" min-width="10"></el-table-column>
          <el-table-column prop="createTime" label="创建日期" min-width="10"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="10">
            <template v-slot="scope">
              <span v-for="item in statusList" :key="item.value">{{ item.value == scope.row.status ? item.label : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" @click="chack(scope.row, 'check')">查看<br></span>
              <span class="color-blue" v-if="scope.row.status === 0" ref="operationRef" v-show="pageType == 'review'" @click="chack(scope.row, 'review')">审核<br></span>
              <span class="color-blue" v-if="$hasPermission('crm:admin:store:updateStore') && scope.row.status == 1" v-permission="'crm:admin:store:updateStore'" @click="chack(scope.row, 'edit')"
                ref="operationRef">编辑<br></span>
              <span class="color-blue" @click="dialogVisible = true, storeCodeItem = scope.row.code, storeIdItem = scope.row.id, discountItem = scope.row.discount"
                v-if="scope.row.status == 1">设为失效</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
    <!-- 添加编辑审核查看平台 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="storeDialog" width="650px" v-if="storeDialog" @close="storeClose">
      <el-form ref="form" :model="storeFrom" label-width="130px">
        <el-form-item label="活动产品名称：">
          <el-button class="search-ok" @click="checkProdList" round>查看产品列表</el-button>
        </el-form-item>
        <el-form-item label="起止时间："> {{ storeFrom.startTime }} 至<span v-if="title !== '编辑'" style="margin-left: 10px;"> {{ storeFrom.endTime }}</span><el-date-picker v-model="storeFrom.endTime"
            type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" style="margin-left: 10px;width: 200px;" v-else>
          </el-date-picker></el-form-item>
        <el-form-item label="平台号:" prop="num">
          <div v-if="!storeFrom.id">
            <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
            </el-autocomplete>
            <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
            <span v-show="show">平台名称:{{ storeName }}</span>
          </div>
          <div v-else>{{ storeFrom.code }} 平台名称:{{ storeFrom.storeName }}</div>
        </el-form-item>
        <el-form-item label="充值金额:" prop="money">
          <!-- <el-input v-model="storeFrom.money" clearable v-if="title == '编辑' || title == '关联平台'"></el-input> -->
          <el-input-number v-model="storeFrom.money" :min="0" :precision="2" :step="0.01" :controls="false" v-if="title == '编辑' || title == '关联平台'" />
          <div v-else>{{ storeFrom.money }}</div>
        </el-form-item>
        <el-form-item label="折扣力度:" prop="discount">
          <div v-if="title == '编辑' || title == '关联平台'">
            <el-input-number v-model="storeFrom.discount" :min="0.1" :max="9.9" :precision="1" :step="0.1" :controls="false" @change="handleChange" placeholder="请输入0.1-9.9之间的数值" />
            <div>折扣填写大于等于0.1小于10的数值，小数点保留一位</div>
          </div>
          <div v-else>{{ storeFrom.discount }}</div>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="storeFrom.remark" clearable v-if="title == '编辑' || title == '关联平台'"></el-input>
          <div v-else>{{ storeFrom.remark }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div v-if="title == '审核'">
          <el-button type=" " @click="confirmStore(2)">审核拒绝</el-button>
          <el-button type="primary" @click="confirmStore(1)">审核通过</el-button>
        </div>
        <el-button type="primary" @click="confirmStore(0)" v-else>确定</el-button>
      </span>
    </el-dialog>
    <!-- 查看产品列表 -->
    <div class="prod-list">
      <el-dialog :close-on-click-modal="false" title="产品列表" :visible.sync="productDialog" width="1500px" height="100vh">
        <productList v-if="productDialog" :storeProd="true"></productList>
      </el-dialog>
    </div>
    <!-- 设为失效提示 -->
    <el-dialog title="确认提示" :visible.sync="dialogVisible" width="30%">
      <span>是否确认将{{ storeCodeItem }}的{{ discountItem }}折折扣包设为失效?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="invalidate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import productList from '@/views/ProductAdmin/ProductList/index.vue'
import VPagination from '@/components/Pagination/index.vue'
import { storeTypeGetStoreTypeList, storeExport, storeQueryListByCode, storeQueryByStoreCode } from '@/api/crm'
import { packageExport, discountPackageList, discountPackageAdd, discountPackageDetail, discountPackageEdit, discountPackageAudit, discountPackageInvalidate, getDiscount } from '@/api/pms'
export default {
  name: 'platform-message',
  components: {
    VPagination,
    productList
  },
  data () {
    return {
      discountList: [],
      title: '关联平台',
      statusList: [
        {
          value: 0,
          label: '待审核'
        },
        {
          value: 1,
          label: '已审核'
        },
        {
          value: 2,
          label: '已拒绝'
        },
        {
          value: 3,
          label: '已失效'
        }
      ],
      storeCodeItem: '',
      storeIdItem: '',
      discountItem: '',
      dialogVisible: false,
      pageType: '', // 用于判断是不是审核菜单
      productDialog: false,

      storeDialog: false,
      show: false,
      storeFrom: {
        money: '',
        storeId: '',
        discount: 0,
        remark: '',
        endTime: '2026-12-31 23:59:59',
        startTime: this.$moment().format('YYYY-MM-DD HH:mm:ss')
      },
      code: '',
      storeName: '',
      formInline: {
        storeName: '',
        storeId: '',
        status: '',
        discount: '',
        createTimeStart: '',
        createTimeEnd: ''
      },
      tableData: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      platformType: [],
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      value2: [
        // this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        // this.$moment().format('YYYY-MM-DD')
      ],
      storeListByCode: []
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        if (val) {
          this.formInline.createTimeStart = val[0] ? val[0] + ' 00:00:00' : ''
          this.formInline.createTimeEnd = val[1] ? val[1] + ' 23:59:59' : ''
        } else {
          this.formInline.createTimeStart = ''
          this.formInline.createTimeEnd = ''
        }
      },
      deep: true,
      immediate: true
    },
    $route: {
      handler: function (newRoute, oldRoute) {
        console.log('当前路由：', newRoute)
        console.log('之前的路由：', oldRoute)
        if (newRoute.path == '/epay/discountBagReview') {
          this.formInline.status = 0
          this.pageType = 'review'
        } else {
          this.pageType = ''
          this.formInline.status = ''
        }
        if (oldRoute && (oldRoute.path == '/epay/discountBagReview' || oldRoute.path == '/epay/discountBag')) {
          this.getPlatformType()
          this.searchPlateform()
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  computed: {

  },
  created () {
    this.getPlatformType()
    this.searchPlateform()
  },
  methods: {
    async chack (row, type) {
      if (row) {
        let res = await discountPackageDetail(row.id)
        if (res.data.success) {
          this.storeFrom = res.data.data
          this.storeFrom.code = res.data.data.storeCode
          this.storeFrom.storeName = res.data.data.storeName
        }
      }
      this.storeDialog = true
      this.title = type == 'check' ? '查看' : type == 'review' ? '审核' : type == 'edit' ? '编辑' : '关联平台'
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    // 折扣力度
    getDiscountList (val) {
      this.discountList = []
      if (val.trim()) {
        getDiscount(val).then(res => {
          if (res.data.success) {
            this.discountList = res.data.data
          }
        })
      }
    },
    getPlatformType () {
      storeTypeGetStoreTypeList().then((res) => {
        this.platformType = res.data.data
      })
    },
    searchPlateform () {
      console.log('查询', this.formInline)
      discountPackageList({ ...this.formInline, pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.searchPlateform()
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let _this = this
      packageExport(_this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '折扣包表' + this.$moment().format('YYYY-MM-DD HH:mm:ss') + '.xls'
          if (this.value2.length) {
            _fileName = '折扣包表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          }
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    sizeChange (pageSize) {
      this.queryInfo.pageSize = pageSize
      this.getPageData()
    },
    pageIndexChange (pageIndex) {
      this.queryInfo.pageNum = pageIndex
      this.getPageData()
    },
    getPageData () {
      this.queryInfo.total = Math.ceil(this.queryInfo.total / this.queryInfo.pageSize)
      this.tableData = this.tableData.slice(this.queryInfo.pageSize * (this.queryInfo.pageNum - 1), this.queryInfo.pageSize * this.queryInfo.pageNum)
    },
    // 关联平台
    handleChange (value) {
      if (value < 0.1) {
        this.storeFrom.discount = 0.1
      } else if (value >= 10) {
        this.storeFrom.discount = 9.9
      }
    },
    handleSelect (item) {
      this.storeFrom.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    // 验证平台
    verifyStore () {
      storeQueryByStoreCode(this.code).then(res => {
        if (res.data.data.exist) {
          this.storeFrom.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.show = true
        } else {
          this.$message.error('平台不存在')
        }
      })
    },
    // 查看产品列表
    checkProdList () {
      this.productDialog = true
    },
    // 确定关联
    async confirmStore (type) {
      if (type == 0) {
        if (this.title == '关联平台') {
          if (!this.storeFrom.storeId) {
            this.$message.error('请验证平台')
            return
          }
          let res = await discountPackageAdd(this.storeFrom)
          if (res.data.success) {
            this.$message.success('添加成功')
            this.storeClose()
            this.searchPlateform()
          }
        } else if (this.title == '编辑') {
          if (!this.storeFrom.remark) {
            this.$message.error('请填写备注')
            return
          }
          let res = await discountPackageEdit(this.storeFrom)
          if (res.data.success) {
            this.$message.success('编辑成功')
            this.storeClose()
            this.searchPlateform()
          }
        } else {
          this.storeDialog = false
        }
      } else {
        let res = await discountPackageAudit({ id: this.storeFrom.id, status: type })
        if (res.data.success) {
          if (type == 1) {
            this.$message.success('审核已通过')
          } else {
            this.$message.success('审核已拒绝')
          }
          this.storeClose()
          this.formInline.status = ''
          this.searchPlateform()
        }
      }
    },
    storeClose () {
      this.storeDialog = false
      this.code = ''
      this.storeName = ''
      this.show = false
      this.storeFrom = {
        money: '',
        storeId: '',
        discount: 0,
        remark: '',
        endTime: '2026-10-31 23:59:59',
        startTime: this.$moment().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    // 设为失效
    async invalidate () {
      let res = await discountPackageInvalidate(this.storeIdItem)
      if (res.data.success) {
        this.$message.success('设置成功')
        this.searchPlateform()
      }
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
// @deep: ~">>>";

// @{deep} .data-list .el-table tr td {
//   height: 40px !important;
//   padding: 0 !important; 
// }
.prod-list {
  /deep/.el-dialog {
    margin-top: 10px !important;
  }

  /deep/ .el-dialog__body {
    padding: 0 !important;
    height: calc(100vh - 130px) !important;
  }
}
</style>
